import React from 'react'

import { FormattedMessage } from 'react-intl'

import { definitions } from 'api/generated/location'

export const createLocationName = (location: definitions['NamedLocation']) =>
  (location.cityName && (
    <FormattedMessage
      id="landing.city"
      values={{ cityName: location.cityName }}
      defaultMessage="г. {cityName}"
    />
  )) ||
  location.regionName ||
  location.countryName
